import { CategorieArticoli } from './categorieArticoli';

export class TipiArticoli {
  id: number;
  descrizione: string;
  idCategoria:number;
  propJSON: string;
  usaMatricola: boolean;
  immateriale: boolean;
  categoria: CategorieArticoli;
}